<template>
    <router-view></router-view>
</template>
<script>
export default {
  name: 'cost-control-management',
};
</script>
